import React from 'react'

export default function MiniFooter() {
  return (
   

<div className="container py-4">

    <div className="row">
        <div className="col-12 text-center">
             © {new Date().getFullYear()} <span>FIROZ DEV</span>. All Rights Reserved.
        </div>
    </div>
</div>


  )
}
